/* eslint-disable max-len */
import axios from 'axios';

export const getOptionsChoicesAndMetadata = async (host, productId) => {
  try {
    const response = await axios.get(`${host}/Catalog/ProductConfiguration/GetConfiguratorOptionsWithExternalProductId?productId=${productId}`);
    return response?.data;
  } catch (err) {
    return null;
  }
};
